import { Grid, Typography } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import { toInteger } from 'lodash';
import React from 'react';

const grandSeperator = val => {
	if(!val) {
		return "0"
	}
	
	val = val
		.toString()
		.replace(/,/g, '')
		.replace(/ /g, '');
	let parsed = parseInt(val);

	if (!isNaN(parsed)) {
		return parsed.toLocaleString().replace(/,/g, ' ');
	} else {
		return val;
	}
};

const customRow = (firstCol, secondCol, thirdCol) => {
	return (
	  <React.Fragment>
		<Grid item xs={12} sm={12} md={12}>
		  <Grid container>
			<GridItem xs={3} sm={3} md={3}>
			  {firstCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {secondCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {thirdCol}
			</GridItem>
			<GridItem xs={5} sm={5} md={5}>
			  
			</GridItem>
		  </Grid>
		</Grid>
	  </React.Fragment>
	);
  };

const EstateDuty = props => {
	const estateDuty = props.state.result.estateDuty;

	return (
		<React.Fragment>
			{/* ============================== Assets =================================*/}
			{/* =============================================================================*/}

			<Grid
				direction="column"
				style={{ marginTop: '20px', marginBottom: '20px' }}
			>
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Assets: </strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<b>R {grandSeperator(estateDuty.assets.netEstateAssets)}</b>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Assets from balance sheet
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.assets.netAssets)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Farms
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.assets.netFarms)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Deemed Assets
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.assets.netDeemedAssets)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Policies On Your Life
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.assets.netPoliciesOnLife)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Policies with a cash value (Client owner, not life assured)
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.assets.netPoliciesWithChash)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Accrual claim against surviving spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R{' '}
						{grandSeperator(
							estateDuty.assets.claimAgainstSpouse
						)}
					</Typography>,
					null
				)}

				<div style={{ marginTop: '20px' }} />
				{/* ================= Deductions =========================*/}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Deductions:</strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<b>R {grandSeperator(toInteger(estateDuty.deductions.netDeductions))}</b>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Liabilities
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netLiabilities)}
					</Typography>,
					null
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Administration
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netAdministration)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Funeral
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netFuneral)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Masters Fees
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netMastersFee)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Executors Fees
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(toInteger(estateDuty.deductions.netExectutorsFee))}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Capital Gains Tax
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netCapitalGainTax)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Transfer Costs
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netTransferCosts)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Value of assets bequethed to surviving spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R{' '}
						{grandSeperator(
							toInteger(estateDuty.deductions.netBequethedAssets)
						)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Cash bequests to spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netCashBequestTospouse)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Residue to surviving spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(toInteger(estateDuty.deductions.netResidueTospouse))}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Policies to surviving spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netPoliciesToSpouse)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Bequests to charities
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.bequestsToCharities)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Cash bequests to charity
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netCashBequestToCharity)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Accrual claim
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.deductions.netAccrualClaim)}
					</Typography>,
					null
				)}
				

				<div style={{ marginTop: '20px' }} />
				{/* ================= Nett Estate =========================*/}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Nett Estate:</strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<b>R {grandSeperator(toInteger(estateDuty.netEstate))}</b>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Minus: Rebate
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.minusRebate)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Minus: Rebate carried from previous spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R{' '}
						{props.state.spouseDeath && grandSeperator(
							estateDuty.minusRebate - estateDuty.minusRebateFromPreviousSpouse
						)}
						{!props.state.spouseDeath && grandSeperator(0.00)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Taxable Estate</strong>
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.taxableEstate)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Estate Duty payable</strong>
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(estateDuty.estateDutyPayable)}
					</Typography>,
					null
				)}

				<div style={{ marginTop: '20px' }} />
				{/* ================= Apportionment of Estate duty =========================*/}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Apportionment of Estate duty:</strong>
					</Typography>,
					null,
					null
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Payable By Others
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R{' '}
						{grandSeperator(
							toInteger(estateDuty.payableByOther)
						)}
					</Typography>,
					null
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Payable By Estate
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R{' '}
						{grandSeperator(
							toInteger(estateDuty.payableByEstate)
						)}
					</Typography>,
					null
				)}
			</Grid>
		</React.Fragment>
	);
};

export default EstateDuty;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/EstateDuty.jsx